import React from "react";
import RouterLinkButton from "components/buttons/RouterLinkButton";
import routes from "routes";
import { IStyledButtonProps } from "components/buttons/StyledButton";

interface IProps extends IStyledButtonProps {}

export default function NewsArticleBackButton(props: IProps) {
    return (
        <RouterLinkButton
            to={routes.news.route}
            textStyle={{ display: "flex", alignItems: "center" }}
            {...props}
        >
            All News
        </RouterLinkButton>
    );
}
